module.exports = __webpack_public_path__ + "static/media/studio_construction_telehandler_mht_790_manitou_004.c00d7cee.png";